import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../shared/Services/authentication.service";
import { Observable, of } from "rxjs";

export const superAdminGuard = (): Observable<boolean> => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  if (auth.isBackofficeSuperadmin()) return of(true);

  if (auth.isBackOffice()) 
    router.navigateByUrl('/back-office/dashboard');

  if (auth.isDealer()) 
    router.navigateByUrl('/dealer-system/dashboard');
  
  return of(false);
};
